export class CentroCostoSelectOption {
  value: any;
  label: string;

  constructor(data: any) {
    if (!!data.id) {
      this.value = data.id;
    } else {
      this.value = data.cc;
    }
    if (!!data.customText) {
      this.label = data.customText;
    } else {
      this.label = data.denominacion;
    }
  }
}
